var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAutogiro = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#E84E1B;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68,80H12C5.4,80,0,74.6,0,68V12C0,5.4,5.4,0,12,0h56c6.6,0,12,5.4,12,12v56C80,74.6,74.6,80,68,80z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.5,20.3V16c0-3.5-0.3-5.8-0.9-6.9C37.1,8,35.6,7.5,33,7.5c-4.6,0-6.8,0.9-6.8,2.6c0,0.5,0.2,1.1,0.6,1.7 s0.6,1.3,0.6,2.1c0,1.2-0.4,2-1.1,2.6s-1.6,0.9-2.6,0.9c-1.2,0-2.2-0.4-2.9-1.2c-0.7-0.8-1-1.7-1-2.7c0-2.2,1.3-4.1,3.9-5.7 s6.3-2.3,11-2.3c3.8,0,6.5,0.4,8.3,1.3s2.8,2,3.2,3.2c0.4,1.3,0.6,3.1,0.6,5.5v15.5c0,2.3,0.2,3.7,0.5,4.3s0.8,0.8,1.5,0.8 c1,0,2-0.7,3-2.1h1c-0.7,4.1-3.1,6.2-7.2,6.2c-3.9,0-6.2-2.2-7-6.7c-3.3,4.5-7.1,6.7-11.6,6.7c-2.9,0-5.3-0.8-7-2.4 s-2.6-3.5-2.6-5.8C17.4,24.9,24.4,21,38.5,20.3z M38.5,26.8v-4.6c-5.2,0.2-8.6,1-10.3,2.3c-1.7,1.4-2.5,3.3-2.5,5.9 c0,1.9,0.5,3.3,1.5,4.4c1,1,2.1,1.6,3.4,1.6c1.7,0,3.2-0.6,4.5-1.7c1.3-1.1,2.2-2.2,2.7-3.4C38.3,30.3,38.5,28.8,38.5,26.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.3,36.1c-1.1,0-1.5,1.2-2.9,2.2s-2.2,2.1-2.2,3.2c0,1,0.4,1.7,1.1,2.2c0.8,0.5,2.7,0.8,5.7,0.8L52.5,44 c3,0,5.5,1,7.3,2.9c1.9,1.9,2.8,4.6,2.8,8.2c0,4.1-1.7,7.6-5.1,10.4c-3.4,2.8-8.1,4.2-14.1,4.2c-4.7,0-8.4-0.9-11.1-2.8 c-2.7-1.9-4.1-4.1-4.1-6.6c0-1.5,0.4-2.8,1.3-3.9c0.9-1.1,2.8-2.5,5.9-4.2c-4.7-1.1-7-3.7-7-7.7c0-5.4,2.9-8.4,8.7-9.1v-0.2 L36.3,36.1z M37.8,52.2c-2.7,1.7-4,4.2-4,7.5c0,5.2,3.6,7.8,10.7,7.8c4.6,0,8.3-1.1,11.3-3.2c3-2.1,4.4-4.6,4.4-7.5 c0-1.7-0.7-3-2.2-4c-1.5-0.9-3.2-1.4-5-1.4c-0.7,0-2.4,0.1-4.9,0.3c-2.6,0.2-4.5,0.3-5.7,0.3L37.8,52.2z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAutogiro);
export { ForwardRef as ReactComponent };